import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import Modal from "../../../elements/Modal";
import {
  addFailureData,
  editFailureData,
} from "../../../../modules/executions";
import { Form } from "react-bootstrap";
import { useNotification } from "../../../../hooks/NotificationContext";
import TextInput from "../../../elements/TextInput";

const categories = ["Applications", "Automation"];
const appSubCategories = [
  "Bug",
  "Slowness",
  "App Crash",
  "Infrastructure Error",
];
const autoSubCategories = [
  "Coding error",
  "Locator change",
  "Synchronization issue",
  "Functional change not updated",
  "Test data not available",
];

const AddEditFailure = ({
  show,
  handleClose,
  fetchData,
  testCaseId,
  executionId,
  loading,
  mode,
  selectedItem,
}) => {
  const defaultData = {
    category: selectedItem?.category || "Applications",
    subCategory: selectedItem ? selectedItem?.sub_category : "",
    description: selectedItem?.description || "",
  };
  const { addNotification } = useNotification();
  const [formData, setFormData] = useState(defaultData);

  const createFailureRecord = async () => {
    let failureData = {
      failure: {
        ...formData,
        testCaseId: testCaseId,
        executionId: executionId,
      },
    };
    try {
      mode === "add" ? await addFailureData(failureData) : await editFailureData(failureData, selectedItem?.id);
      fetchData();
      addNotification("success", `Item ${mode === "add" ? "added" : "updated"} successfully`);
      handleClose();
    } catch (error) {
      const errorMessage =
        error.message || `Failed to ${mode === "add" ? "add" : "update"}  item. Please try again`;
      addNotification("error", errorMessage);
    }
  };

  useEffect(() => {
    setFormData(defaultData);
  }, [selectedItem]);

  const subCategoryMenu =
    formData?.category === "Automation" ? autoSubCategories : appSubCategories;
  return (
    <Modal
      open={show}
      width={"md"}
      handleClose={handleClose}
      modalTitle={mode === "add" ? "Add Analysis" : "Edit Analysis"}
      action={() => (
        <>
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={createFailureRecord}
            disabled={loading}
          >
            Submit
          </Button>
        </>
      )}
    >
      <Form noValidate onSubmit={createFailureRecord}>
        <Grid container spacing={1}>
          <Grid item md={6}>
            <Stack>
              <InputLabel id="category" className="required">Category</InputLabel>
              <Select
                labelId="category"
                id="category"
                value={formData.category}
                required
                onChange={(e) =>
                  setFormData({ ...formData, category: e.target.value, subCategory: "" })
                }
              >
                {categories.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          </Grid>
          <Grid item md={6}>
            <Stack>
              <InputLabel id="subCategory" className="required">Sub-Category</InputLabel>
              <Select
                labelId="subCategory"
                id="subCategory"
                value={formData.subCategory}
                required
                onChange={(e) =>
                  setFormData({ ...formData, subCategory: e.target.value })
                }
              >
                {subCategoryMenu.map((category) => (
                  <MenuItem key={category} value={category}>
                    {category}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 3 }}>
          <Grid item md={12}>
            <Stack>
              <InputLabel>Description</InputLabel>
              <TextInput
                id="description"
                value={formData.description}
                onChange={(field, value) =>
                  setFormData({ ...formData, description: value })
                }
                maxLength={500}
                placeholder="Enter Description"
                type="textarea"
                rows={3}
              />
            </Stack>
          </Grid>
        </Grid>
      </Form>
    </Modal>
  );
};

export default AddEditFailure;
